import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import { env } from '~/commons/config';

import Nav from './layout/Nav.jsx';
import Footer from './layout/Footer.jsx';
import Layout from './layout/Layout.jsx';
import {
  PageCompetition,
  PageDashboard,
  PageAnnouncements,
  PageAnnouncement,
  PageQa,
  PageViewSlot,
} from './pages';
import ModalAnnouncement from './modals/ModalAnnouncement.jsx';
import ModalAlert from './modals/ModalAlert.jsx';
import AutoLogout from './blocks/AutoLogout.jsx';

const App = () => (
  <ModalAlert>
    <Router basename={env.base}>
      <Layout>
        <ModalAnnouncement />
        <AutoLogout delay={1000 * 60 * 60} />
        <Nav />
        <div className="content">
          <div className="w-100">
            <Switch>
              <Route path="/app" exact>
                <PageDashboard />
              </Route>
              <Route exact path="/app/announcements">
                <PageAnnouncements title="比賽提示" path="app" />
              </Route>
              <Route exact path="/app/announcements/:_id">
                <PageAnnouncement />
              </Route>
              <Route exact path="/app/competition">
                <PageCompetition />
              </Route>
              <Route exact path="/app/qa">
                <PageQa />
              </Route>
              <Route path="*">
                <PageViewSlot />
              </Route>
            </Switch>
          </div>
        </div>
        <Footer />
      </Layout>
    </Router>
  </ModalAlert>
);

export default App;
